class PatientTaskItem {
    public IndividualMessageId: string;
    public Subject: string;
    public FromEmployee: string;
    public ToEmployees: string[];
    public Body: string;
    public SendDate: Date;
    public StartDate: Date;
    public DueDate: Date;
    public Priority: string;
    public Type: string;
    public IsGroupTask: boolean;
    public OverallTaskStatusLookupId: string;
    public PriorityLookupId: string;
}

export { PatientTaskItem };
